import {Link} from "react-router-dom";
import { motion } from "framer-motion"
import ServiceNavbar from "../cpa/components/ServiceNavbar";
function Cpa() {
    return (
        <>
            {/* <!-- banner --> */}
            <div className="banner">
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                        }}>
                    <img src="./cpaImg/CPA.jpg" alt=""/>
                </motion.div>
                <div className="cpabannertext dis">
                    Becker<br/>
                    學分班<br/>
                    <div className="fs-1 dis">
                    加州州立大學東灣分校
                    </div>
                </div>
            </div>
            {/* <!-- Service Nav--> */}
            <ServiceNavbar/>
            <div className="container-fluid mb100 text-center">
                <img src="./csuImg/csu.jpg" alt=""/>
            </div>
            {/* <!-- USCPA 有助生涯&職涯規劃 --> */}
            <div className="container mb100 mt100">
                
                <div className="w-75 m-auto">
                    <h2>The Bridging Program 美國會計師學分班介紹</h2>
                    <iframe allow="accelerometer, autoplay, clipboard-write, encrypted-media, gyroscope, picture-in-picture" allowfullscreen="" frameborder="0" height="315" src="https://www.youtube.com/embed/B58AH08YCWA" title="YouTube video player" width="560"></iframe>
                <p><strong>學員心得</strong></p>
                前期學分班學員已發表心得！<br/>

                「價格不算太高，但能節省非常大量的時間，從半年變成幾周就能解決，所以就馬上聯繫Becker的櫃檯人員。」<br/>

                「學分班才有的最後 Simulation 解題總複習，我認為對赴美考前衝刺還不錯。」<br/>

                「跟著老師的課程複習講解，真的能省下好幾天的時間。祝福大家考照順利，學分趕快補一補，開始上工！」<br/>
                <a href="https://beckertw.com/cate/72">點此閱讀更多</a>
                </div>
                <div className="w-75 mx-auto mt100">
                <p><strong>適用族群</strong></p>

                英澳加學歷者、綠卡移民、跨科系、四大上班族等，<b>尚缺學分</b>以報考美國會計師考試、需<b>短時間補修完畢者</b>。<br/>
                </div>

                <div className="w-75 mx-auto mt100">
                    <p><strong>修課優勢</strong></p>

                    <p><strong>省錢上萬、省力二合一、省時一年：</strong></p>
                    <ul>
                        <li>在台修讀美國學分，與美國本校相比，學費省一半</li>
                        <li>上完 Becker CPA 考試補習課程，不需再另花時間補學分</li>
                        <li>省下近一整年在校修課學分量</li>
                        <li>所得學分可直接使用報名美國會計師考試，免學歷認證費用與等待時間</li>
                        <li>購買 Becker 準備考試時，即會使用&nbsp;Becker CPA 中文課程，省去額外另修學分的時間與交通成本<br /></li>
                    </ul>
                    <span className="mt-3"><strong>全新課程製作審核完畢，2025年1月起回歸開課！</strong></span>
                </div>

                <div className="w-75 mx-auto mt100">
                    <p>每學期課程依照當下 U.S. CPA 考試範圍設計。因應2024年起考試改制、課程內容大幅改變，新年度學分班內容經學校再次嚴格審核與批准，爾後授予修畢者學分證明，<strong><span>2025年1月正式重啟，全新開班！</span></strong></p>
                    <p><strong>開課單位</strong></p>
                    <p>Becker Taiwan (捷進顧問) 與加州州立大學東灣分校 (California State University, East Bay) 合作開設。</p>
                </div>
                <div className="container">
                    <div class="table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead>
                            <tr>
                                <th>學分課程代碼</th>
                                <th>課程名稱與教學範圍</th>
                                <th>適用 Becker CPA 教材範圍</th>
                                <th>學分種類</th>
                                <th class="text-right">學分數量</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>ACCT 811c</td>
                                <td>
                                <p><strong>Financial Accounting and Reporting I<br/>財務會計與報告一</strong></p>
                                <p>
                                    Course objectives are to provide the knowledge and skills a CPA must demonstrate in the financial accounting and reporting frameworks used by business entities. Topics include conceptual framework, financial reporting, financial statements and disclosures.<br/>
                                    此門課的學習目標是提供企業財務會計與報告框架的知識與技能，以美國註冊會計師（US CPA）必須掌握的程度為準。課程內容包括概念框架、財務報告、財務報表及揭露事項。
                                </p>
                                <p>
                                    Will not satisfy course requirement in accounting degree program.<br/>
                                    此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。
                                </p>
                                <p><em>Prerequisite: None<br/>修課條件：無。</em></p>
                                </td>
                                <td>FAR 1-2</td>
                                <td>Accounting<br/>會計類</td>
                                <td class="text-right">3</td>
                            </tr>

                            <tr>
                                <td>ACCT 812c</td>
                                <td>
                                <p><strong>Financial Accounting and Reporting II<br/>財務會計與報告二</strong></p>
                                <p>
                                    Course objectives are to provide the knowledge and skills a CPA must demonstrate in the financial accounting and reporting frameworks used by business entities. Topics include monetary assets, inventory, property, plant and equipment, intangibles, investments, business combinations, and goodwill.<br/>
                                    此門課的學習目標是提供企業財務會計與報告框架的知識與技能，以美國註冊會計師（US CPA）必須掌握的程度為準。課程內容包括貨幣性資產、存貨、土地廠房及設備、無形資產、投資、企業合併及商譽。
                                </p>
                                <p>
                                    Will not satisfy course requirement in accounting degree program.<br/>
                                    此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。
                                </p>
                                <p><em>Prerequisite: None<br/>修課條件：無。</em></p>
                                </td>
                                <td>FAR 3-4</td>
                                <td>Accounting<br/>會計類</td>
                                <td class="text-right">3</td>
                            </tr>

                            <tr>
                                <td>ACCT 813c</td>
                                <td>
                                <p><strong>Financial Accounting and Reporting III<br/>財務會計與報告三</strong></p>
                                <p>
                                    Course objectives are to provide the knowledge and skills a CPA must demonstrate in the financial accounting and reporting frameworks used by business entities. Topics include investments, statements of cash flow, income taxes, nonprofit accounting, and governmental accounting.<br/>
                                    此門課的學習目標是提供企業財務會計與報告框架的知識與技能，以美國註冊會計師（US CPA）必須掌握的程度為準。課程內容包括投資、現金流量表、所得稅、非營利組織會計及政府會計。
                                </p>
                                <p>
                                    Will not satisfy course requirement in accounting degree program.<br/>
                                    此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。
                                </p>
                                <p><em>Prerequisite: None<br/>修課條件：無。</em></p>
                                </td>
                                <td>FAR 5-6</td>
                                <td>Accounting<br/>會計類</td>
                                <td class="text-right">3</td>
                            </tr>

                            <tr>
                                <td>ACCT 816c</td>
                                <td>
                                <p><strong>Auditing &amp; Attestation I<br/>審計與鑑證一</strong></p>
                                <p>
                                    Course objectives are to provide the knowledge and skills a CPA must demonstrate when performing audit engagements for issuer and non-issuer entities. Topics include audit reports, professional standards, audit engagements, audit opinion, quality control, audit planning, and internal control.<br/>
                                    此門課的學習目標是提供美國註冊會計師（US CPA）在執行對公開發行公司及非公開發行公司的審計業務時，必須具備的知識與技能。課程內容包括審計報告、專業標準、審計業務、審計意見、品質控制、審計規劃及內部控制。
                                </p>
                                <p>
                                    Will not satisfy course requirement in accounting degree program.<br/>
                                    此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。
                                </p>
                                <p><em>Prerequisite: None<br/>修課條件：無。</em></p>
                                </td>
                                <td>AUD 1-2</td>
                                <td>Accounting<br/>會計類</td>
                                <td class="text-right">3</td>
                            </tr>

                            <tr>
                                <td>ACCT 817c</td>
                                <td>
                                <p><strong>Auditing &amp; Attestation II<br/>審計與鑑證二</strong></p>
                                <p>
                                    Course objectives are to provide the knowledge and skills a CPA must demonstrate when performing audit engagements for issuer and non-issuer entities. Topics include fraud, audit and engagement risk, evidence, sampling, performing further procedures, forming conclusions, and communications.<br/>
                                    此門課的學習目標是提供美國註冊會計師（US CPA）在執行對公開發行公司及非公開發行公司的審計業務時，必須具備的知識與技能。課程內容包括舞弊、審計與業務風險、證據、抽樣、執行進一步程序、形成結論及溝通。
                                </p>
                                <p>
                                    Will not satisfy course requirement in accounting degree program.<br/>
                                    此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。
                                </p>
                                <p><em>Prerequisite: None<br/>修課條件：無。</em></p>
                                </td>
                                <td>AUD 3-4</td>
                                <td>Accounting<br/>會計類</td>
                                <td class="text-right">3</td>
                            </tr>

                            <tr>
                                <td>ACCT 818c</td>
                                <td>
                                <p><strong>Auditing &amp; Attestation III<br/>審計與鑑證三</strong></p>
                                <p>
                                    Course objectives are to provide the knowledge and skills a CPA must demonstrate when performing audit engagements for issuer and non-issuer entities. Topics include integrated audits, attestation engagements, compliance, government audits, accounting and review service, interim reviews, ethics, professional responsibilities.<br/>
                                    此門課的學習目標是提供美國註冊會計師（US CPA）在執行對公開發行公司及非公開發行公司的審計業務時，必須具備的知識與技能。課程內容包括整合性審計、查證業務、合規性、政府審計、會計及審閱服務、中期審閱、倫理及專業責任。
                                </p>
                                <p>
                                    Will not satisfy course requirement in accounting degree program.<br/>
                                    此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。
                                </p>
                                <p><em>Prerequisite: None<br/>修課條件：無。</em></p>
                                </td>
                                <td>AUD 5-6</td>
                                <td>Accounting<br/>會計類</td>
                                <td class="text-right">3</td>
                            </tr>

                            <tr>
                                <td>ACCT 819c</td>
                                <td>
                                <p><strong>Federal Income Taxation I - Individuals<br/>聯邦所得稅一：個人</strong></p>
                                <p>
                                    Course objectives are to provide the knowledge and skills a CPA must demonstrate for U.S. federal taxation. Topics include individual taxation on filing requirements, gross income, adjustments, itemized deductions, tax computation, and property taxation on basis, dispositions, gains and losses.<br/>
                                    此門課的學習目標是提供美國註冊會計師（US CPA）在美國聯邦稅務方面必須具備的知識與技能。課程內容包括個人稅務的申報要求、總收入、調整項目、列舉扣除、稅額計算，以及財產稅務中基礎、處分、收益與損失。
                                </p>
                                <p>
                                    Will not satisfy course requirement in accounting degree program.<br/>
                                    此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。
                                </p>
                                <p><em>Prerequisite: None<br/>修課條件：無。</em></p>
                                </td>
                                <td>REG 1-2</td>
                                <td>Accounting<br/>會計類</td>
                                <td class="text-right">3</td>
                            </tr>

                            <tr>
                                <td>ACCT 820c</td>
                                <td>
                                <p><strong>Federal Income Taxation II - Entities<br/>聯邦所得稅二：企業</strong></p>
                                <p>
                                    Course objectives are to provide the knowledge and skills a CPA must demonstrate for U.S. federal taxation. Topics include corporate taxation, flow-through entity taxation and multi-jurisdictional tax issues, trusts and estates, gifts, tax-exempt organizations, professional responsibilities, and federal tax procedures.<br/>
                                    此門課的學習目標是提供美國註冊會計師（US CPA）在美國聯邦稅務方面必須具備的知識與技能。課程內容包括公司稅務、通過實體稅務、多管轄區稅務問題、信託及遺產、贈與、免稅組織、專業責任及聯邦稅務程序。
                                </p>
                                <p>
                                    Will not satisfy course requirement in accounting degree program.<br/>
                                    此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。
                                </p>
                                <p><em>Prerequisite: None<br/>修課條件：無。</em></p>
                                </td>
                                <td>REG 3-4</td>
                                <td>Accounting<br/>會計類</td>
                                <td class="text-right">3</td>
                            </tr>

                            <tr>
                                <td>ACCT 821c</td>
                                <td>
                                <p><strong>Business Law<br/>美國商事法</strong></p>
                                <p>
                                    Course objectives are to provide the knowledge and skills that a CPA must demonstrate with respect to U.S. business law. Topics include agency, contracts, suretyship, secured transactions, bankruptcy, federal securities regulation, other federal laws and regulations, and business structures.<br/>
                                    此門課的學習目標是提供美國註冊會計師（US CPA）在美國商法方面必須具備的知識與技能。課程內容包括代理、契約、保證、擔保交易、破產、聯邦證券法規、其他聯邦法律與法規，以及商業架構。
                                </p>
                                <p>
                                    Will not satisfy course requirement in accounting degree program.<br/>
                                    此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。
                                </p>
                                <p><em>Prerequisite: None<br/>修課條件：無。</em></p>
                                </td>
                                <td>REG 5-6</td>
                                <td>Business<br/>商業類</td>
                                <td class="text-right">3</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="4" class="text-right"><strong>商業類學分數總計</strong></td>
                                <td class="text-right"><strong>3</strong></td>
                            </tr>
                            <tr>
                                <td colspan="4" class="text-right"><strong>會計類學分數總計</strong></td>
                                <td class="text-right"><strong>24</strong></td>
                            </tr>
                            <tr>
                                <td colspan="4" class="text-right"><strong>全部學分數總計</strong></td>
                                <td class="text-right"><strong>27</strong></td>
                            </tr>
                            </tfoot>
                        </table>
                        </div>

                </div>
                    預告：除了上述項目，未來將另增加 3 門商業分析、稅務、資訊科技學分項目，待美國校方完成審核後公告。
                <div className="w-75 mx-auto mt100">
                    <p><strong>課表</strong></p>
                    <a href="https://drive.google.com/file/d/1kmpBvY8koz9nhlxDvxZdyMNbmy9A8gUe/view"><span>2025上半年度面授課表日期</span></a>
                    ，面授已結業，現可隨時以雲端（隨選隨看影片，不參加面授）的方式，觀看中文雲端課程、完成全線上學習。
                </div>
                <div className="w-75 mx-auto mt100">
                <p><strong>上課方式（中＋英模式）</strong></p>

                    首先，以實體面授上課或雲端隨選隨看（二選一）方式參加 Becker Taiwan 台灣講師教授的中文課程，每堂課為3小時；<br/>
                    課前或課後，請搭配觀看 Becker CPA Exam Review 軟體上、相關單元範圍的美籍講師教學影片。
                </div>

                <div className="w-75 mx-auto mt100">
                    <p><strong>評量方式</strong></p>
                    每門學分班，及格與計分方式：<br/>
                    <ul>
                        <li>完成 Becker Taiwan 中文課程 (每堂3小時＋美籍講師影片）</li>
                        <li>學員本人 Becker CPA Exam Review 軟體上，該門課程單元範圍之：
                        <ul>
                            <li>單選題 (MCQ)，完成百分比將被採計為 25% 之學分班成績</li>
                            <li>單選題 (MCQ)，已完成題目之答題正確率將被採計為 25% 之學分班成績</li>
                        </ul>
                        </li>
                        <li>參加線上期末考，答題正確率將被採計為 50% 之學分班成績
                        <ul>
                            <li>期末考為24~42題之單選題 (MCQ)，以及1~3題之情境模擬題 (Simulation)</li>
                        </ul>
                        </li>
                        <li>以上學分班成績項目加總，得分百分比達 60% 以上為及格</li>
                    </ul>
                    以上為學分班評量準則；請留意不同學分項目可能存在微幅差異，請依各門課程大綱敘述為準。<br />
                </div>

                <div className="w-75 mx-auto mt100">
                    
                    <p><strong>期末考試</strong></p>
                    每門學分班之期末考限時，120 分鐘，提供兩種應考方式（二選一）：<br/>
                    <ul>
                        <li><strong>線上考</strong>，需預約，US$20.00，於 <a href="https://examroom.ai/">ExamRoom.ai</a>&nbsp;線上考試平台進行。</li>
                        <li><strong>實體考</strong>，需預約，免費，於 Becker Taiwan 台北大安教室進行。</li>
                    </ul>
                    
                </div>

                <div className="w-75 mx-auto mt100">
                <p><strong>選課身份</strong></p>

                    Becker Taiwan 之美國註冊會計師 (CPA) 軟體效期內、並有中文課程使用額度之學員<br/>
                </div>

                

                <div className="w-75 mx-auto mt100">
                <p><strong>學分費用</strong></p>
                    每門3學分之學分班，定價：新台幣 30,000 元<br/>
                    限時團報：2025年12月31日前，個人或揪團報名學分班滿 3 門課，可享每門課減免新台幣 10,000 元之優惠。<br/>

                </div>

                <div className="w-75 mx-auto mt100">
                
                    <button className="btn btn-success"><strong><Link className="text-light" to={`/registration?parent_id=5`}>申請報名</Link></strong></button>
                </div>

                <div className="w-75 mx-auto mt100">
                <p><strong>限時團報，活動條款</strong></p>
                    <ul>
                        <li>揪團報名學分班者，需相繼於 7 日內完成學分班之報名清款，團報條件方可成立。</li>
                        <li>優惠期限為即日起至 2025 年 12 月 31&nbsp;日&nbsp;23:59。</li>
                        <li>在適⽤法律允許的範圍內，Becker Taiwan 保留不經通知即變更本促銷活動的條款與細則， 或是在任何時候不經通知即變更或結束本促銷活動的權利。</li>
                    </ul>
                </div>


            </div>
        </>
    );
}
export default Cpa;